var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiFiNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70718 1.29291 1.29297 2.70712 5.28378 6.69793C4.13182 7.32506 3.04932 8.12591 2.07475 9.10048 2.04966 9.12557 2.02469 9.15073 1.99984 9.17595L3.4141 10.5902C3.43892 10.565 3.46388 10.5398 3.48897 10.5147c.98329-.9833 2.09477-1.76027 3.28065-2.33093L8.24546 9.65961C6.97256 10.1465 5.77913 10.9029 4.75317 11.9289l1.41422 1.4142c1.05204-1.052 2.3242-1.7498 3.66822-2.0933l1.75479 1.7547C10.1336 13.0609 8.69352 13.6452 7.58138 14.7573l1.41421 1.4143c1.56211-1.5621 4.09481-1.5621 5.65681.0L14.7049 16.1191l6.5881 6.588 1.4142-1.4142L2.70718 1.29291zM13.3275 9.11292l4.1919 4.19188 1.3759-1.3759c-1.5691-1.5692-3.53-2.50781-5.5678-2.81598zM9.44382 5.22925 11.2371 7.0225C14.5161 6.82191 17.8618 7.96102 20.384 10.4398l1.4143-1.41423C18.4242 5.70136 13.7828 4.43593 9.44382 5.22925zM13.238 17.5858C12.457 16.8047 11.1906 16.8047 10.4096 17.5858L11.8238 19l1.4142-1.4142z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFiNo);
export default __webpack_public_path__ + "static/media/wi-fi-no.8a5e9fc3.svg";
export { ForwardRef as ReactComponent };